import { Defect, DefectSeverity, DefectStatus, UpdateDefectRequest } from '../../models/defect.model';

export interface DefectDraft {
  status: DefectStatus;
  severity: DefectSeverity;
  assigneeUserId: string | null;
  markedBlocking: boolean;
  /** Nachtest-Angaben (Bundle page-fehler.jsx:232-234); zählen nur, solange der Entwurf „Behoben“ ist. */
  fixedInBuild: string;
  retestByUserId: string | null;
  requestRetest: boolean;
}

export type DefectChanges = Omit<UpdateDefectRequest, 'version'>;

export function draftOf(defect: Defect): DefectDraft {
  return {
    status: defect.status,
    severity: defect.severity,
    assigneeUserId: defect.assignee?.userId ?? null,
    markedBlocking: defect.markedBlocking,
    fixedInBuild: defect.retest?.fixedInBuild ?? '',
    retestByUserId: defect.retest?.retestBy?.userId ?? defect.createdBy?.userId ?? null,
    requestRetest: true,
  };
}

export function draftChanges(defect: Defect, draft: DefectDraft): DefectChanges {
  const saved = draftOf(defect);
  const changes: DefectChanges = {};
  if (draft.status !== saved.status) changes.status = draft.status;
  if (draft.severity !== saved.severity) changes.severity = draft.severity;
  if (draft.assigneeUserId !== saved.assigneeUserId) {
    if (draft.assigneeUserId) changes.assigneeUserId = draft.assigneeUserId;
    else changes.unassign = true;
  }
  if (draft.markedBlocking !== saved.markedBlocking) changes.markedBlocking = draft.markedBlocking;
  if (draft.status === 'FIXED') Object.assign(changes, retestChanges(saved, draft));
  return changes;
}

/** Beim Wechsel auf „Behoben“ gehen Build, Person und Haken immer mit, danach nur Geändertes. */
function retestChanges(saved: DefectDraft, draft: DefectDraft): DefectChanges {
  const build = draft.fixedInBuild.trim();
  const retestBy = draft.retestByUserId ?? undefined;
  if (saved.status !== 'FIXED') {
    return {
      fixedInBuild: build,
      ...(retestBy ? { retestByUserId: retestBy } : {}),
      requestRetest: draft.requestRetest,
    };
  }
  const changes: DefectChanges = {};
  if (build !== saved.fixedInBuild) changes.fixedInBuild = build;
  if (retestBy && retestBy !== saved.retestByUserId) changes.retestByUserId = retestBy;
  return changes;
}

export function buildMissing(draft: DefectDraft): boolean {
  return draft.status === 'FIXED' && !draft.fixedInBuild.trim();
}
